import Vue from 'vue'
import Router from 'vue-router'
import Intro from '../components/Intro.vue'
import Login from '../components/Login.vue'
import Signup from '../components/Signup.vue'
import Home from '../components/Home.vue'
import Sub from '../components/Sub.vue'


Vue.use(Router);  // 뷰에서 라우터 사용 선언

// 라우터 설정시작
var router = new Router({
  mode: 'history',
  routes: [
    // 페이지별 링크 주소 
    {path: '/', component: Intro },
    {path: '/login', component: Login },
    {path: '/signup', component: Signup },
    {path: '/home', component: Home },
    {path: '/sub', component: Sub }
  ]
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js